function useSentenceCaseText(str: string | undefined | null) {
  if (!str) {
    return null;
  }

  const label: string = str[0].toUpperCase() + str.slice(1).toLowerCase();

  return label;
}

export default useSentenceCaseText;
